<div
  [ngClass]="
    'rating flex gap-2 items-center mb-2' + (isInHeader() ? ' rating--header' : '')
  "
>
  @if (showRatingNumber()) {
    <span
      [ngClass]="
        'rating__average mobi-ui-font-bold mobi-ui-text-inked mobi-ui-font-realist mobi-ui-text-inked ' +
        (isInHeader()
          ? ' mobi-ui-font-size-200 md:mobi-ui-font-size-400 min-w-6 md:min-w-8'
          : ' mobi-ui-font-size-550 min-w-[50px] mr-1')
      "
    >
      <!-- Make sure that the slot is kept if the rating is not loaded -->
      @if (rating()) {
        {{ animatedRating().toFixed(1) }}
      } @else {
        0.0
      }
    </span>
  }
  <div class="rating__stars">
    @for (star of [1, 2, 3, 4, 5]; track $index) {
      <div class="rating__star">
        <svg
          [ngClass]="'w-' + starSize() + ' h-' + starSize()"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 576 512"
        >
          <defs>
            <clipPath [attr.id]="getClipPathId(star)">
              <rect
                [attr.width]="getStarFill(star)"
                height="512"
                class="star-fill-rect"
                [style.transition-delay]="getDelay(star)"
              />
            </clipPath>
          </defs>
          <!-- Gray star (background) -->
          <path
            class="star-back"
            d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
          />
          <!-- Red star (foreground) -->
          <path
            class="star-front"
            [attr.clip-path]="'url(#' + getClipPathId(star) + ')'"
            d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
          />
        </svg>
      </div>
    }
  </div>
</div>
